import React from 'react'
import founderPic from "../../Assests/jasmin.jpg"
import Angel from "../../Assests/Gouri.png"
import Gouri from "../../Assests/Angel.png"
import Crystal from "../../Assests/Crystal.jpeg"

function weAre() {
  return (
    <div className='bg-white pt-20'>


{/* ── PAGE HEADER ── */}
<div className='text-center pt-20 pb-10 px-4'>
  <p className='text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-3'>Our Team</p>
  <div className='flex items-center justify-center gap-3 mb-4'>
    <div className='h-[1px] w-12 bg-[#E40F94]'></div>
    <span className='text-[#E40F94] text-sm'>♦ ◇ ♦</span>
    <div className='h-[1px] w-12 bg-[#E40F94]'></div>
  </div>
  <h1 className='font-bold text-[48px] md:text-[56px] leading-tight text-gray-900' style={{fontFamily: "'Playfair Display', serif"}}>About <span className='text-[#E40F94] italic'>Us</span></h1>
  <p className='text-gray-500 text-[16px] mt-3'>Meet the team behind the magic</p>
  <div className='w-16 h-[3px] bg-[#E40F94] rounded-full mx-auto mt-6'></div>
</div>
      {/* ── FOUNDER SECTION ── */}
      <div className='md:px-[192px] px-6 py-16'>
        <div className='flex flex-col md:flex-row items-center md:items-start gap-12'>

          {/* Founder Photo */}
          <div className='flex-shrink-0 text-center'>
            <div className='group relative overflow-hidden rounded-2xl shadow-2xl border-4 border-[#E40F94]'>
              <img
                src={founderPic}
                className='w-[320px] md:w-[360px] object-cover object-top transition-transform duration-500 group-hover:scale-105'
                alt="Jasmin Eapen"
              />
              <div className='absolute inset-0 bg-black opacity-0 group-hover:opacity-10 transition-opacity duration-300'></div>
            </div>
            <div className='mt-4'>
              <p className='text-[#E40F94] font-bold text-[16px] uppercase tracking-widest'>Jasmin Eapen</p>
              <p className='text-gray-500 text-[14px] uppercase tracking-[3px] mt-1'>Founder & Director</p>
            </div>
          </div>

          {/* Founder Bio */}
          <div className='flex-1'>
            <p className='text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-4'>Meet Our Director</p>
            <h2 className='text-[32px] md:text-[38px] font-bold text-gray-900 leading-tight mb-6'>Jasmin Eapen</h2>
            <div className='w-12 h-[3px] bg-[#E40F94] rounded-full mb-8'></div>
            <div className='space-y-5 text-[16px] text-gray-600 leading-8 font-light'>
              <p>Jasmin Eapen is a professional dancer with over 30 years of experience and extensive training in Bharatanatyam, Semi-Classical, Bollywood, Bhangra, Garba, and Kerala cinematic dance. She brings both technical precision and artistic expression to her teaching, blending tradition with creativity.</p>
              <p>Jasmin is also a Certified Registered Nurse Anesthetist (CRNA) by profession. Much like anesthesia, where every breath, rhythm, and movement is carefully orchestrated to create a seamless experience, dance follows its own intricate patterns of control and flow. Both disciplines demand focus, discipline, and a deep understanding of rhythm.</p>
              <p>As the director of Chilanka Dance School, Jasmin is passionate about sharing the beauty, discipline, and transformative power of dance. She strives to create a space where students not only refine their technique but also embrace their creativity, connect with their culture, and build confidence through performance.</p>
              <p className='text-[#E40F94] font-medium italic'>Whether you're a beginner discovering the joy of movement or an advanced dancer honing your craft, Chilanka is a place to Move, Inspire, and Shine.</p>
            </div>
          </div>

        </div>
      </div>

      {/* ── INSTRUCTORS SECTION ── */}
      <div className='bg-gray-50 px-6 md:px-[192px] py-20'>
        <div className='text-center mb-14'>
          <p className='text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-3'>The People Behind the Magic</p>
          <h2 className='font-bold text-[40px] md:text-[48px] leading-tight text-gray-900'>Our Instructors</h2>
          <div className='w-16 h-[3px] bg-[#E40F94] rounded-full mx-auto mt-6'></div>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-3 gap-10'>

          {/* Angel */}
          <div className='bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden'>
            <div className='group relative overflow-hidden'>
              <img
                src={Angel}
                className='w-full max-h-[400px] object-cover object-top transition-transform duration-500 group-hover:scale-105'
                alt="Angel Santosh"
              />
              <div className='absolute inset-0 bg-black opacity-0 group-hover:opacity-10 transition-opacity duration-300'></div>
            </div>
            <div className='p-6'>
              <p className='text-[#E40F94] font-bold text-[15px] uppercase tracking-widest mb-1'>Angel Santosh</p>
              <p className='text-gray-400 text-[13px] uppercase tracking-[3px] mb-4'>Assistant Teacher</p>
              <div className='w-8 h-[2px] bg-[#E40F94] rounded-full mb-4'></div>
              <p className='text-gray-500 text-[15px] leading-7 font-light'>Angel is a highly skilled dancer with extensive training in Bharatanatyam and Bollywood dance. Known for her energy, creativity and dedication, Angel inspires her students in every class. Her unwavering commitment to nurturing young dancers has made her a cherished mentor and role model.</p>
            </div>
          </div>

          {/* Gauri */}
          <div className='bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden'>
            <div className='group relative overflow-hidden'>
              <img
                src={Gouri}
                className='w-full max-h-[400px] object-cover object-top transition-transform duration-500 group-hover:scale-105'
                alt="Gauri Hari"
              />
              <div className='absolute inset-0 bg-black opacity-0 group-hover:opacity-10 transition-opacity duration-300'></div>
            </div>
            <div className='p-6'>
              <p className='text-[#E40F94] font-bold text-[15px] uppercase tracking-widest mb-1'>Gauri Hari</p>
              <p className='text-gray-400 text-[13px] uppercase tracking-[3px] mb-4'>Assistant Teacher</p>
              <div className='w-8 h-[2px] bg-[#E40F94] rounded-full mb-4'></div>
              <p className='text-gray-500 text-[15px] leading-7 font-light'>Gauri Hari is a passionate dancer and dedicated teacher who completed her Bharatanatyam Arangetram in 2025. Alongside her classical training, she teaches Bollywood and Kerala folk dance, inspiring students to develop discipline, confidence, and grace.</p>
            </div>
          </div>

          {/* Crystal */}
          <div className='bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden'>
            <div className='group relative overflow-hidden'>
              <img
        src={Crystal}
        className='w-full max-h-[400px] object-cover object-top transition-transform duration-500 group-hover:scale-105'
                alt="Crystal Tennyson"
              />
              <div className='absolute inset-0 bg-black opacity-0 group-hover:opacity-10 transition-opacity duration-300'></div>
            </div>
            <div className='p-6'>
              <p className='text-[#E40F94] font-bold text-[15px] uppercase tracking-widest mb-1'>Crystal Tennyson</p>
              <p className='text-gray-400 text-[13px] uppercase tracking-[3px] mb-4'>Instructor</p>
              <div className='w-8 h-[2px] bg-[#E40F94] rounded-full mb-4'></div>
              <p className='text-gray-500 text-[15px] leading-7 font-light'>Crystal Tennyson is a dynamic dance instructor and trained Bharatanatyam artist with a deep passion for Indian classical and contemporary dance. Also skilled in Bollywood and Odissi, Crystal blends strong technique with creativity and expression, inspiring students to build confidence, embrace culture, and grow as performers.</p>
            </div>
          </div>

        </div>
      </div>

    </div>
  )
}

export default weAre
